import { typesOfAssistanceReq } from "../../../utils/helper";
import { RadioButtonGroup } from "../../atoms/radioButtonGroup/RadioButtonGroup";
import { Container } from "../../atoms/container/Container";
import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Text } from "../../atoms/text/Text";
import style from "./selectassistance.module.scss";

import { useSelectAssistance } from "../../../hooks/useSelectAssistance/UseSelectAssistance";
import { AgentScript } from "../../atoms/agentScript/AgentScript";
import { Flex } from "antd";

interface SelectAssistanceProps {
  ambulanceData?: any;
  isDispatched?: boolean;
}

export const SelectAssistance: React.FC<SelectAssistanceProps> = ({ ambulanceData, isDispatched }) => {
  const { selectedValues, handleOptionChange, numberOfHelpers, handleNumberOfHelpersChange } = useSelectAssistance(ambulanceData);

  const isDisabled = !!isDispatched;

  const handleDisabledClick = () => {
    alert("Once you send the request, the value can’t be changed.");
  };

 
  return (
    <>
      <BackgroundWrapper>
        <Container className={style.wrapper}>
          <Container>
            <Text text="Select Assistance" className={style.title} />
          </Container>
          <Container>
            <Flex className={style.labelRow}>
              <Text
                text="Type of assistance required ?"
                className={style.question}
              />
              <AgentScript
                text='"Do you require a wheelchair or stretcher?"'
                className={style.mobileOnly}
              />
              <AgentScript
                text='"Would you need a paramedic or doctor in the ambulance?"'
                className={style.mobileOnly}
              />
            </Flex>
            <AgentScript
                text='"Do you require a wheelchair or stretcher?"'
                className={style.desktopOnly}
              />
              <AgentScript
                text='"Would you need a paramedic or doctor in the ambulance?"'
                className={style.desktopOnly}
              />
          </Container>

          <Container>
            <div style={{ position: 'relative' }}>
              <div 
                style={isDisabled ? { pointerEvents: 'none' } : {}}
              >
                <RadioButtonGroup
                  column={4}
                  gap={1}
                  className={style.radio_button}
                  type="checkbox"
                  options={typesOfAssistanceReq}
                  name={"radio"}
                  selectedValue={selectedValues}
                  onChange={isDisabled ? () => {} : handleOptionChange}
                />
              </div>
              {isDisabled && (
                <div 
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 10,
                    cursor: 'not-allowed'
                  }}
                  onClick={handleDisabledClick}
                />
              )}
            </div>
          </Container>
          
          {selectedValues.additionalHelp && (
            <div className={style.helper_container} style={{ position: 'relative' }}>
              <Text text="Number of Helpers:" className={style.helper_label} />
              <input
                type="number"
                min="1"
                max="10"
                value={numberOfHelpers}
                onChange={isDisabled ? () => {} : (e) => handleNumberOfHelpersChange(e.target.value)}
                className={style.helper_input}
                style={isDisabled ? { pointerEvents: 'none' } : {}}
              />
              {isDisabled && (
                <div 
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 10,
                    cursor: 'not-allowed'
                  }}
                  onClick={handleDisabledClick}
                />
              )}
            </div>
          )}
        </Container>
      </BackgroundWrapper>
    </>
  );
};
